import _ from 'lodash'
import moment from 'moment'
import common from '@/utils/common'

import * as define from '@/define'

export default {
  /**
   * 権限確認
   * @param {String } funcId 機能ID
   * @return {Object}
   *   {display: Boolean, disabled: Boolean}
   */
  confirmAuthority: (state, getters) => (funcId) => {
    let result = {
      display: false,
      disabled: true
    }
    // SYSTEM権限アカウントであれば、利用可
    if (getters.isSystemAccount()) {
      result = {
        display: true,
        disabled: false
      }
    } else if (funcId) {
      switch (state.role[funcId]) {
        // 0:利用不可
        case 0:
          result.display = true
          break
        // 1:利用可
        case 1:
          result = {
            display: true,
            disabled: false
          }
          break
        // 非表示
        default:
      }
    // funcId の指定がない場合は利用可
    } else {
      result = {
        display: true,
        disabled: false
      }
    }
    return result
  },
  sortedList: (state) => (nameSpace, sort = {}) => {
    if (sort.order == null) {
      return _.get(state, [nameSpace, 'tdLists'], [])
    } else {
      return common.sortListData(state[nameSpace].tdLists, sort)
    }
  },
  attributeKeys: (state) => (siteCode, pageName, areaName) => {
    if (pageName == null || pageName === '' || areaName == null || areaName === '') {
      return []
    }
    return _.chain(state)
      .get(`serviceSiteConfigs.${pageName}.${areaName}_attr`)
      .map((val, key) => {
        return {
          id: key,
          label: _.has(val, siteCode)
            ? _.get(val, `${siteCode}.label`)
            : _.get(val, 'label'),
          order: _.has(val, siteCode)
            ? _.get(val, `${siteCode}.order`)
            : _.get(val, 'order'),
          inputType: _.has(val, siteCode)
            ? Number(_.get(val, `${siteCode}.v.1`))
            : Number(_.get(val, 'v.1')),
          editable: _.has(val, siteCode)
            ? Boolean(Number(_.get(val, `${siteCode}.v.2`)))
            : Boolean(Number(_.get(val, 'v.2')))
        }
      })
      .sortBy('order')
      .value()
  },
  getServiceSiteConfig: (state) => (siteCode, key1, key2, key3) => {
    const key = _.chain(['serviceSiteConfigs', key1, key2, key3, siteCode])
      .filter(val => val)
      .join('.')
      .value()
    return _.get(state, key)
  },
  orderPointConfigCancel: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'order_point_config', 'confirm_dialog', 'order_cancel'),
      'v.0', '0')
  },
  orderPointConfigPoint: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'order_point_config', 'operation_limit', 'point'),
      'v.0', '0')
  },
  orderPointConfigConsumedPoint: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'order_point_config', 'operation_limit', 'consumed_point'),
      'v.0', '0')
  },
  orderPointConfigPointTarget: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'order_point_config', 'cancel_target_point'),
      'v.0', '0')
  },
  toDownloads: (state, getters) => {
    const returnValue = []
    const data = _.get(state, `serviceSiteConfigs.to_download`)
    if (data) {
      Object.keys(data)
        .forEach((key) => {
          returnValue.push({
            key: key,
            downloadKey: data[key].v[0],
            funcId: data[key].v[1],
            displayValue: data[key].abbr
          })
        })
    }
    return returnValue
  },
  allowOverFirstTotalAmount: (state, getters) => (siteCode) => {
    return _.get(
      getters.getServiceSiteConfig(siteCode, 'allow_over_first_total_amount'),
      'v.0', '0')
  },
  allowSameSku: (state, getters) => (siteCode) => {
    return _.get(
      getters.getServiceSiteConfig(siteCode, 'allow_same_sku', 'ship'),
      'v.0', '0')
  },
  allowPartialShipment: (state, getters) => (siteCode) => {
    return _.get(
      getters.getServiceSiteConfig(siteCode, 'allow_partial_shipment', 'ship'),
      'v.0', '0')
  },
  allowDuplicateComponent: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'm_product', 'allowDuplicateComponent'),
      'v.0', '0')
  },
  orderItemTypeName: (state, getters) => (orderItemType) => {
    return _.get(getters.getServiceSiteConfig(null, 'd_order_item', 'order_item_type', orderItemType), 'label')
  },
  siteTaxation: (state, getters) => (siteCode) => {
    return _.get(
      getters.getServiceSiteConfig(siteCode, 'price_calculation', 'site_taxation'),
      'v.0', '0')
  },
  apiErrorReason: (state, getters) => (siteCode, apiName, errorCode) => {
    return _.get(
      getters.getServiceSiteConfig(siteCode, apiName, errorCode),
      'v.0', '')
  },
  wrappingCharge: (state, getters) => (siteCode) => {
    return {
      productId: _.get(
        getters.getServiceSiteConfig(siteCode, 'Wrapping_Charge', 'product_id'),
        'v.0', ''),
      productName: _.get(
        getters.getServiceSiteConfig(siteCode, 'Wrapping_Charge', 'product_name'),
        'v.0', ''),
      lineitemText: _.get(
        getters.getServiceSiteConfig(siteCode, 'Wrapping_Charge', 'lineitem_text'),
        'v.0', '')
    }
  },
  shippingCharge: (state, getters) => (siteCode) => {
    return {
      productId: _.get(
        getters.getServiceSiteConfig(siteCode, 'Shipping_Charge', 'product_id'),
        'v.0', null),
      lineitemText: _.get(
        getters.getServiceSiteConfig(siteCode, 'Shipping_Charge', 'lineitem_text'),
        'v.0', ''),
      editable: _.get(
        getters.getServiceSiteConfig(siteCode, 'Shipping_Charge', 'lineitem_text', 'editable'),
        'v.0', '0')
    }
  },
  codFee: (state, getters) => (siteCode) => {
    return {
      productId: _.get(
        getters.getServiceSiteConfig(siteCode, 'COD_Fee', 'product_id'),
        'v.0', null),
      lineitemText: _.get(
        getters.getServiceSiteConfig(siteCode, 'COD_Fee', 'lineitem_text'),
        'v.0', ''),
      editable: _.get(
        getters.getServiceSiteConfig(siteCode, 'COD_Fee', 'lineitem_text', 'editable'),
        'v.0', '0')
    }
  },
  getOrderPointConfig: (state, getters) => (siteCode, key) => {
    return _.get(getters.getServiceSiteConfig(siteCode, 'order_point_config', 'consumed_point', key),
      'v.0', '')
  },
  getPointAdjustmentConfig: (state, getters) => (siteCode, key) => {
    return _.get(getters.getServiceSiteConfig(siteCode, 'Point_Adjustment', key),
      'v.0', '0')
  },
  getPointAdjustmentEditable: (state, getters) => (siteCode, key) => {
    return _.get(getters.getServiceSiteConfig(siteCode, 'Point_Adjustment', key, 'editable'),
      'v.0', '')
  },
  paymentMethodSelectOptions: (state, getters) => (siteCode) => {
    return _.filter(_.filter(state.sites, { code: siteCode })[0].paymentMethods,
      (v) => { return _.includes([define.PAYMENT_METHOD_TYPE.NO_PROCESS, define.PAYMENT_METHOD_TYPE.HOLD], v.methodType) })
  },
  useMail: (state, getters) => {
    return Boolean(Number(
      _.get(getters.getServiceSiteConfig(null, 'mail', 'send', 'order_cancel'),
        'v.0', '0')
    ))
  },
  isScheduledShippingAt: (state, getters) => (siteCode) => {
    return Boolean(Number(_.get(getters.getServiceSiteConfig(siteCode, 'CCS_order_batch_create_export', 'scheduled_shipping_at',
      null), 'v.0', '0')))
  },
  needConfirm: (state, getters) => {
    return Boolean(Number(
      _.get(getters.getServiceSiteConfig(null, 'mail', 'confirm_dialog', 'order_cancel'),
        'v.0', '0')
    ))
  },
  componentSelectableSkuType: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'm_product', 'search_component_product_target',
        'sku_type'), 'v.0', '').split(',').filter((str) => str !== '')
  },
  exchangeSelectableSkuType: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'm_product', 'search_exchange_product_target',
        'sku_type'), 'v.0', '').split(',').filter((str) => str !== '')
  },
  productBundle: (state, getters) => {
    const bundle = getters.getServiceSiteConfig(null, 'm_product', 'product_category', 'bundle')

    const bundleInfo = {
      colorCode: _.get(bundle, 'v.0', ''),
      sizeCode: _.get(bundle, 'v.1', ''),
      name: _.get(bundle, 'abbr', '')
    }

    return bundleInfo
  },
  productSet: (state, getters) => {
    const set = getters.getServiceSiteConfig(null, 'm_product', 'product_category', 'set')

    const setInfo = {
      colorCode: _.get(set, 'v.0', ''),
      sizeCode: _.get(set, 'v.1', ''),
      name: _.get(set, 'abbr', '')
    }

    return setInfo
  },
  productUneditableItem: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'm_product', 'item', 'Uneditable'),
      'v.0', '').split(',').filter((str) => str !== '')
  },
  skuUneditableItem: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'm_product_sku', 'item', 'Uneditable'),
      'v.0', '').split(',').filter((str) => str !== '')
  },
  productTypeName: (state, getters) => (productType) => {
    return _.get(getters.getServiceSiteConfig(null, 'm_product.product_type',
      productType), 'abbr', '').split(',').filter((str) => str !== '')
  },
  productEditable: (state, getters) => {
    return _.get(
      getters.getServiceSiteConfig(null, 'm_product', 'item', 'editable_uneditable_product'),
      'v.0', '').split(',').filter((str) => str !== '')
  },
  productDefaultValue: (state, getters) => {
    const returnValue = {}
    const defaultValues = _.get(state, `serviceSiteConfigs.m_product.default_config`)
    if (defaultValues) {
      Object.keys(defaultValues)
        .forEach((key) => {
          returnValue[key] = defaultValues[key].v[0]
        })
    }
    return returnValue
  },
  productCodeMaxLength: (state, getters) => () => {
    return Number(_.get(getters.getServiceSiteConfig(null, 'm_product.product_code.max_length'),
      'v.0', '0')) || null
  },
  skuCodeMaxLength: (state, getters) => () => {
    return Number(_.get(getters.getServiceSiteConfig(null, 'm_product.sku_code.max_length'),
      'v.0', '0')) || null
  },
  skuNameAbbreviationMaxLength: (state, getters) => () => {
    return Number(_.get(getters.getServiceSiteConfig(null, 'm_product.sku_name_abbreviation.max_length'),
      'v.0', '0')) || null
  },
  skuTypeEditable: (state, getters) => (skuType) => {
    return Boolean(Number(_.get(getters.getServiceSiteConfig(null, 'm_product.sku_type',
      skuType), 'v.0', '0')))
  },
  skuTypeOptions: (state, getters) => {
    const returnValue = []
    const skuTypes = _.get(state, `serviceSiteConfigs.m_product.sku_type`)
    if (skuTypes) {
      Object.keys(skuTypes)
        .sort((a, b) => {
          return skuTypes[a].order > skuTypes[b].order
        })
        .forEach((key) => {
          returnValue.push({
            code: key,
            name: skuTypes[key].abbr,
            selectable: skuTypes[key].v[0],
            displayTarget: skuTypes[key].v[1]
          })
        })
    }
    return returnValue
  },
  exportIdFormats: (state, getters) => (siteCode) => {
    const returnValue = []
    const formats = _.get(state, `serviceSiteConfigs.d_order_export_id_format`)

    if (formats) {
      Object.keys(formats)
        .forEach((key) => {
          const funcBody = _.get(formats, `${key}.${siteCode}.v.0`, '')
          if (funcBody !== '') {
            // 動的にファンクションを作成するためESLintの例外とする
            // eslint-disable-next-line no-new-func
            const funcExec = new Function('id', funcBody)
            returnValue.push({
              key: key,
              toConvert: funcExec
            })
          }
        })
    }
    return returnValue
  },
  /**
   * SYSTEM権限確認
   * @return {Boolean}
   */
  isSystemAccount: (state, getters) => () => {
    try {
      // SYSTEM権限の判定
      return state.accountType === Number(_.get(getters.getServiceSiteConfig(null, 'm_account', 'system_account_type'), 'v.0', '0'))
    } catch (error) {
      // 設定を正しく取得できていない場合、非SYSTEM権限
      return false
    }
  },
  /**
   * 権限のリストに設定する選択肢の取得
   * @param {String} id 権限のID。指定したIDより弱いものが取得される
   * @param {boolean} admin ADMIN権限の場合
   * @return {Object} リストに設定する選択肢
   */
  getAccountTypeOptions: (state, getters) => (id = 0, admin = false) => {
    let accountTypes = []
    let types = getters.getServiceSiteConfig(null, 'm_account', 'account_type') || []

    Object.keys(types).forEach((key) => {
      accountTypes.push(
        {
          id: Number(key),
          label: _.get(types[key], 'label', null),
          order: _.get(types[key], 'order', null),
          power: Number(_.get(types[key], 'v.0', null))
        })
    })

    const targetType = accountTypes.find((type) => { return type.id === id })
    const power = targetType ? targetType.power : 0
    accountTypes = accountTypes.filter((type) => {
      if (admin) { return type.power >= power } else { return type.power > power }
    })
    accountTypes.sort((typeA, typeB) => { return typeA.order > typeB.order ? 1 : -1 })

    const accountTypeOptions = []
    accountTypes.forEach((type) => accountTypeOptions.push({ code: type.id, name: type.label }))

    return accountTypeOptions
  },
  /**
   * 権限の強さの取得
   * @param {String} id 権限のID。指定したIDより弱いものが取得される
   * @return {Object} リストに設定する選択肢
   */
  getAccountTypePower: (state, getters) => (id = 0) => {
    let accountTypes = []
    let types = getters.getServiceSiteConfig(null, 'm_account', 'account_type') || []

    Object.keys(types).forEach((key) => {
      accountTypes.push(
        {
          id: Number(key),
          power: Number(_.get(types[key], 'v.0', null))
        })
    })
    const targetType = accountTypes.find((type) => { return type.id === id })
    const power = targetType ? targetType.power : null
    return power
  },
  // 検索条件モーダルの値を取得
  searchConditions: (state, getters) => (storePath) => {
    const searchKeyword = state[storePath].searchKeyword
    const isAndSearch = state[storePath].isAndSearch
    const searchConditions = state[storePath].searchConditions
    const maxGetCount = state[storePath].maxGetCount

    // 検索キーワードを取得
    let condition = {
      keyword: (isAndSearch ? '& ' : '') + searchKeyword
    }
    // 検索パネルを取得
    _.forEach(searchConditions, (v, k) => {
      if (v.display && v.value.length > 0) {
        if (v.isAttribute) {
          const workCondition = {}
          workCondition.key = k
          switch (v.type) {
            case 'Input':
              workCondition.value = v.value
              break
            case 'SingleSelector':
              if (v.valueType === 1) {
                workCondition.value = Number(v.value)
              } else {
                workCondition.value = v.value
              }
              break
            case 'MultiSelector':
              if (v.valueType === 1) {
                workCondition.value = v.value.map(v => Number(v))
              } else {
                workCondition.value = v.value
              }
              break
            case 'Date':
              workCondition.value = {}
              workCondition.value.From = v.value[0]
              workCondition.value.To = moment(v.value[1]).add(1, 'd').utc().format()
              break
            case 'DateTime':
              workCondition.value = {}
              workCondition.value.From = v.value[0]
              workCondition.value.To = moment(v.value[1]).add(1, 's').utc().format()
              break
            case 'NumberRange':
              workCondition.value = {}
              if (v.value[0]) {
                // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                workCondition.value.From = String(v.value[0])
              }
              if (v.value[1]) {
                // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                workCondition.value.To = String(v.value[1])
              }
              break
            default:
          }
          if (condition.xAttribute == null) {
            condition.xAttribute = JSON.stringify({
              searchKey: state[storePath].searchKey,
              conditionValue: [workCondition]
            })
          } else {
            const tempAttribute = JSON.parse(condition.xAttribute)
            tempAttribute.conditionValue.push(workCondition)
            condition.xAttribute = JSON.stringify(tempAttribute)
          }
        } else {
          switch (v.type) {
            case 'Input':
              condition[k] = v.value
              break
            case 'SingleSelector':
              if (v.valueType === 1) {
                condition[k] = Number(v.value)
              } else {
                condition[k] = v.value
              }
              break
            case 'MultiSelector':
              if (v.valueType === 1) {
                condition[k] = v.value.map(v => Number(v))
              } else {
                condition[k] = v.value
              }
              break
            case 'Date':
              condition[`${k}From`] = v.value[0]
              condition[`${k}To`] = moment(v.value[1]).add(1, 'd').utc().format()
              break
            case 'DateTime':
              condition[`${k}From`] = v.value[0]
              condition[`${k}To`] = moment(v.value[1]).add(1, 's').utc().format()
              break
            case 'NumberRange':
              if (v.value[0]) {
                // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                condition[`${k}From`] = String(v.value[0])
              }
              if (v.value[1]) {
                // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                condition[`${k}To`] = String(v.value[1])
              }
              break
            default:
          }
        }
      }
    })
    // 最大取得件数
    if (maxGetCount != null) {
      Object.assign(condition, { first: maxGetCount })
    }
    return condition
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js